import React from "react";
import { cn } from "@/lib/utils";
import { userError } from "@/lib/userError";

export const RefreshNotice = ({ refreshing, error, updatedAt, onRetry }) => (refreshing || error) ? (
  <div role="status" className="mb-3 rounded-xl border border-border bg-card p-3 text-sm">
    {refreshing ? "Päivitetään tietoja… Aiemmin haetut tiedot näkyvät alla." : userError(error, "Päivitys ei onnistunut. Aiemmin haetut tiedot näkyvät alla.")}
    {updatedAt && <p className="text-xs text-muted-foreground">Viimeksi haettu {updatedAt.toLocaleTimeString("fi-FI")}</p>}
    {error && <button type="button" onClick={onRetry} className="min-h-11 text-primary">Yritä päivitystä uudelleen</button>}
  </div>
) : null;

export const PageHeader = ({ icon: Icon, title, subtitle, action }) => (
  <div className="page-heading flex flex-wrap items-start justify-between gap-3 mb-6 fade-up">
    <div className="flex items-start gap-3 min-w-0">
      {Icon && (
        <div className="mt-1 flex h-8 w-6 shrink-0 items-center justify-center text-primary" aria-hidden="true">
          <Icon className="h-5 w-5" />
        </div>
      )}
      <div>
        <h1 className="font-heading text-[1.75rem] font-semibold tracking-tight text-foreground leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
    </div>
    {action}
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint, action }) => (
  <div className="flex flex-col items-center justify-center py-6 px-2 text-center">
    {Icon && <Icon className="h-7 w-7 text-muted-foreground/60 mb-2" aria-hidden="true" />}
    <p className="font-medium text-foreground">{title}</p>
    {hint && <p className="text-sm text-muted-foreground mt-1">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const LoadingCards = ({ count = 3 }) => (
  <div className="space-y-3">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="h-24 rounded-2xl border border-border/70 bg-muted/70 animate-pulse" />
    ))}
  </div>
);

export const ErrorState = ({ onRetry, error }) => (
  <div className="rounded-2xl border border-destructive/30 bg-destructive/10 p-5 text-center">
    <p className="font-medium text-foreground">Tietojen lataus epäonnistui</p>
    <p className="text-sm text-muted-foreground mt-1">{userError(error, "Tietoja ei saatu juuri nyt. Yritä uudelleen.")}</p>
    {onRetry && (
      <button
        type="button"
        data-testid="error-retry-btn"
        onClick={onRetry}
        className={cn("mt-3 rounded-full bg-primary px-4 py-1.5 text-sm font-semibold text-primary-foreground")}
      >
        Yritä uudelleen
      </button>
    )}
  </div>
);
